class CacheService {
  constructor() {
    this.cache = new Map();
    this.timestamps = new Map();
    this.CACHE_DURATION = 30 * 60 * 1000; // 30 minutes
    this.FRESH_DURATION = 2 * 60 * 1000; // 2 minutes
  }

  set(key, data) {
    if (data && (Array.isArray(data) ? data.length > 0 : Object.keys(data).length > 0)) {
      this.cache.set(key, data);
      this.timestamps.set(key, Date.now());
    }
  }

  get(key) {
    const timestamp = this.timestamps.get(key);
    if (!timestamp) return null;
    
    // Check if cache is expired
    if (Date.now() - timestamp > this.CACHE_DURATION) {
      this.cache.delete(key);
      this.timestamps.delete(key);
      return null;
    }
    
    return this.cache.get(key);
  }

  has(key) {
    return this.get(key) !== null;
  }

  clear(key) {
    if (key) {
      this.cache.delete(key);
      this.timestamps.delete(key);
    } else {
      this.cache.clear();
      this.timestamps.clear();
    }
  }

  isFresh(key) {
    const timestamp = this.timestamps.get(key);
    if (!timestamp) return false;
    return Date.now() - timestamp < this.FRESH_DURATION;
  }

  isStale(key) {
    const timestamp = this.timestamps.get(key);
    if (!timestamp) return true;
    return Date.now() - timestamp > this.FRESH_DURATION;
  }
}

export const cacheService = new CacheService();